module.exports = __webpack_public_path__ + "img/t.1a67064c.png";